import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import image13 from  "../../Images/sweepydo_image13.jpg";
import { Link } from "react-router-dom";


function TermCondition() {
  return (
  <>
  <section className="d-flex flex-column flex-md-row align-items-center justify-content-between"
  style={{
    minHeight: "260px",
    // height: "220px",
    
    color: "#121313",
    padding: "20px clamp(20px, 5vw, 60px)",
    backgroundImage: `url(${image13})`,
    backgroundSize: "cover",
    backgroundPosition: "center top",
    backgroundRepeat: "no-repeat",
    backgroundColor: "#f5f5f5",
    position: "relative",
    overflow: "hidden",
    fontFamily: "'Montserrat', sans-serif",
    height: "450px",
  }}>
     <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundColor: "rgba(255, 255, 255, 0.45)",
            zIndex: 0,
          }}
        ></div>

         <div
          style={{
            position: "relative",
            zIndex: 1,
            flex: 1,
            textAlign: "center",
            marginBottom: "10px",
          }}
        >
          <h1
            className="fw-bold"
            style={{
              fontSize: "clamp(34px, 4vw, 58px)",
              margin: 0,
              fontWeight: "700",
            }}
          >
            Term & Condition
          </h1>
        </div>

        
        <div
          style={{
            position: "relative",
            zIndex: 1,
            flex: 1,
            textAlign: "center",
          }}
        >
          <div
            style={{
              fontSize: "clamp(14px, 1.2vw, 16px)",
              color: "#555",
              fontWeight: "500",
            }}
          >
            <span
              style={{ cursor: "pointer", color: "#6A20Af" }}
              onClick={() => (window.location.href = "/")}
            >
              Home
            </span>{" "}
            &gt; <span>Privacy Policy</span>
          </div>
        </div>
  </section>

   <section style={{ padding: "60px 15px", backgroundColor: "#f9f9f9" }}>
          <Container>
            <Row className="justify-content-center">
              <Col md={10} lg={9}>

                 <div style={{ background: "#fff", padding: "30px", borderRadius: "12px" }}>

          <h2 style={{ fontWeight: "700", marginBottom: "10px" }}>
            Terms & Conditions for Sweepydo
          </h2>

          <p><b>Last Updated:</b> 01/11/2026</p>

          <p>At Sweepydo, we are committed to providing reliable, convenient, and transparent home-service experiences. This Refund & Cancellation Policy explains the terms applicable to cancellations, refunds, staff arrival, customer unavailability, staff preferences, and cancellations initiated by Sweepydo.
By placing a booking through Sweepydo, the customer acknowledges and agrees to the terms mentioned below.
</p>

          <hr />

          <h5>1. Customer-Initiated Cancellation Before Staff Arrival</h5>
          <p>
If a customer cancels a confirmed booking before the assigned service professional reaches the customer's location, the customer will be eligible for a refund after deduction of 5% of the total booking amount.
Refund Amount = Total Payment − 5% Cancellation Deduction
The 5% deduction covers applicable booking, payment processing, administrative, and operational costs associated with the cancelled booking.<br />

Example: If the customer has paid ₹1,000:<br />
•	Total Payment: ₹1,000<br />
•	Cancellation Deduction (5%): ₹50<br />
•	Refund Amount: ₹950

          </p>
          <p>
            If you do not agree with these Terms, you must not use the Platform.
          </p>

          <h5>2. Refund Processing Timeline</h5>
          <p>
Eligible refunds will generally be processed within 24 hours to 7 business days, depending on the payment method, banking partner, payment gateway, and applicable processing timelines.
The refund may reflect in the customer's bank account, card, UPI account, or original payment source after processing by the relevant financial institution.
<br />Note: The refund processing period begins after Sweepydo approves and initiates the eligible refund.
          </p>


          <h5>3. Cancellation After Staff Reaches the Customer's Location</h5>
          <p>
If the customer cancels the booking after the assigned service professional has reached the customer's location, no refund will be provided.
This includes situations where the customer changes their mind or decides not to avail the booked service after the service professional has arrived.<br />
In such cases:<br />
•	No refund will be issued.<br />
•	The booking will not be rescheduled.<br />
•	Any applicable travel, operational, or staff deployment costs will not be refundable.
          </p>

          <h5>4. Customer Unavailable / Unable to Contact</h5>
          <p>If the service professional reaches the customer's location and attempts to contact the customer, but the customer is unavailable or cannot be reached for any reason, the booking will be treated as a customer-side service failure/cancellation.
No refund will be provided in such cases.<br />
This may include, but is not limited to:<br />
•	Customer not being available at the location.<br />
•	Customer not answering calls.<br />
•	Customer not responding to messages.<br />
•	Customer providing an incorrect or incomplete address.<br />
•	Customer denying access to the premises.<br />
•	Customer being unreachable after the service professional arrives.<br />
The booking will not be rescheduled or refunded in such cases.
</p>

          <h5>5. Customer Refusal of Assigned Service Professional</h5>

          <p>
Once a service professional has been assigned and dispatched to the customer's location, the customer is expected to accept the assigned professional and allow the booked service to be performed.
If the customer refuses the service professional after arrival for reasons such as:<br />
•	"I don't want this staff member."<br />
•	"I want a different staff member."<br />
•	"I don't want a male staff member."<br />
•	"I don't want a female staff member."<br />
•	Any other personal preference regarding the assigned staff member,
then the booking will be considered a customer-initiated cancellation after staff arrival.<br />
In such cases:<br />
•	No refund will be issued.<br />
•	The booking will not be rescheduled.<br />
Customers who have specific staff preferences should communicate such requirements before confirming the booking, wherever such preferences are supported by Sweepydo.
          </p>

<h5>6. Cases Where Refund Is Not Applicable</h5>
<p>Refunds and rescheduling will not be provided in the following circumstances:<br />
1.	Customer cancels after the service professional reaches the location.<br />
2.	Customer is unavailable after the service professional reaches the location.<br />
3.	Customer cannot be contacted after arrival.<br />
4.	Customer refuses to allow the assigned professional to provide the service.<br />
5.	Customer refuses the assigned professional due to gender preference or personal preference after arrival.<br />
6.	Customer provides an incorrect/incomplete address resulting in unsuccessful service delivery.<br />
7.	Customer denies or fails to provide access to the premises.<br />
8.	Customer otherwise prevents the service professional from commencing the booked service after arrival.<br />
Where a refund is expressly stated as not applicable under this policy, the same booking will also not be eligible for rescheduling.
</p>

          <h5>7. Cancellation by Sweepydo</h5>
          <p>
If Sweepydo cancels a confirmed booking due to reasons attributable to Sweepydo, including operational issues, service unavailability, or inability to fulfil the booking, the customer will be offered either:<br />
Option A — Full Refund<br />
The customer may receive a 100% refund of the amount paid.<br />
Option B — Rescheduling<br />
The customer may choose to reschedule the booking to another available date/time, subject to availability.
Rescheduling will be carried out only with the customer's agreement.
The customer will not be required to accept rescheduling if they prefer a refund.
          </p>

          <h5>8. Service Delays or Operational Issues</h5>
          <p>
In certain situations, operational circumstances may cause a delay in service delivery. Sweepydo may communicate with the customer and offer an alternative available time slot where reasonably possible.
Any refund arising specifically from a Sweepydo-initiated cancellation will be handled in accordance with Section 7 of this policy.
          </p>

          <h5>9. Refund Method</h5>
<p>Approved refunds will normally be processed to the original payment method used for the booking, subject to the capabilities and policies of the relevant payment gateway or financial institution.<br />
Customers should ensure that the payment account details remain active and accessible until the refund is received.
</p>

          <h5>10. Refund Status & Customer Support</h5>
         <p>If a customer believes they are eligible for a refund but has not received the amount within the applicable processing period, they may contact Sweepydo Customer Support with:<br />
•	Booking ID<br />
•	Registered mobile number<br />
•	Payment confirmation/screenshot<br />
•	Date of booking<br />
•	Relevant transaction details<br />
Sweepydo may request additional information to verify the booking and payment before processing or investigating the refund.
</p>

          <h5>11. Important Customer Notice</h5>
          <p>
Customers are requested to carefully review their booking details, service location, preferred service requirements, and availability before confirming a booking.
Once a service professional has been dispatched, operational resources and travel arrangements may already have been committed to the booking.
Accordingly, cancellations after staff arrival, customer unavailability, refusal of the assigned professional, or denial of access are not eligible for refund or rescheduling.
          </p>




          <h5>12. Contact</h5>
          <p>
For refund or cancellation-related queries, customers may contact Sweepydo Customer Support through the official support channels available on the Sweepydo application or website.          </p>




     
          <h6>Sweepydo</h6>
          <p>Quick Home Services, Simplified.</p>
          
      </div>
  


  
              </Col>
            </Row>
          </Container>
        </section>
  </>
  )
}

export default TermCondition